import { Box, Button, Flex, FormControl, FormErrorMessage, FormLabel, Grid, HStack, Input, useToast } from "@chakra-ui/react"
import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import * as z from "zod"
import { useNavigate } from "react-router-dom"
import { createLanguage} from "src/view-models/Languages"
import Select, { components } from 'react-select';
import { useEffect, useState } from "react"
import { useAppSelector } from "src/redux/hooks"
import { languages10Options } from "../../constants"

const formSchema = z.object({
  name: z.string().min(1, {
    message: "Le nom est obligatoire",
  }),
  code: z.string().min(1, {
    message: "Le prénom est obligatoire",
  }),
  direction: z.string().min(1, {
    message: "Le prénom est obligatoire",
  }),
  flag: z.string().optional().nullable(),
})

type NewAdmFormInputs = {
  name: string
  code: string
  direction: string
  flag: string | undefined
};

const NewLanguageForm = () => {
  const toast = useToast()
  const navigation = useNavigate()
  const { languages } = useAppSelector((state) => state.language)
  const [isManuelLanguage, setIsManualLanguage] = useState(false)

  const { handleSubmit, setValue, register, watch, formState: { errors, isSubmitting }, } = useForm<NewAdmFormInputs>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      name: "", code: "", direction: "ltr", flag: undefined
    }
  });

  const onSubmit = async (values: z.infer<typeof formSchema>) => {
    let theValues = { ...values, flag: undefined };
    if (values?.code === "ar") {
      theValues = { ...theValues, direction: "rtl" }
    }
    const response: any = await createLanguage(theValues, toast)
    if (response.status === true) {
      navigation("/admin/languages")
    } else {
      return null
    }
  }

  const [languagesOptions, setLanguagesOptions] = useState(languages10Options)
  const handleChange = (e: any) => {
    setValue("name", e?.label)
    setValue("code", e?.value)
    setValue("flag", e?.flag)
  }

  useEffect(() => {
    if (languages && languages.length > 0) {
      const formatLanguages = languages?.map((l) => l.code)
      const filtredLanguages = languagesOptions?.map((language) => formatLanguages?.includes(language.value) ? { ...language, isDisabled: true } : language)
      setLanguagesOptions(filtredLanguages)
    }
  }, [languages])

  const switchToManuelLanguageForm = () => {
    setIsManualLanguage(true)
  }

  const switchToSelectLanguageForm = () => {
    setValue("name", ""); setValue("code", ""); setValue("direction", "ltr"); setValue("flag", undefined)
    setIsManualLanguage(false)
  }

  const CustomMenu = (props: any) => {
    return (
      <components.Menu {...props}>
        {props.children}
        <Button
          sx={{ width: "100%" }}
          onClick={switchToManuelLanguageForm}
        >
          Ajouter une langue manuellement
        </Button>
      </components.Menu>
    );
  };


  return (
    <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
      {isManuelLanguage && (
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={switchToSelectLanguageForm}>Ajouter une langue via la select</Button>
        </Box>
      )}
      {isManuelLanguage ? (
        <>
          <FormControl isRequired isInvalid={!!errors.name}>
            <FormLabel>Nom</FormLabel>
            <Input
              boxShadow='sm'
              disabled={isSubmitting}
              rounded='5px'
              type='text'
              size='md'
              id='name'
              placeholder='name'
              {...register("name")}
            />
            <FormErrorMessage>
              {errors.name && errors.name.message}
            </FormErrorMessage>
          </FormControl>
          <FormControl isRequired isInvalid={!!errors.code}>
            <FormLabel>Code</FormLabel>
            <Input
              boxShadow='sm'
              disabled={isSubmitting}
              rounded='5px'
              type='text'
              size='md'
              id='code'
              placeholder='code'
              {...register("code")}
            />
            <FormErrorMessage>
              {errors.code && errors.code.message}
            </FormErrorMessage>
          </FormControl>
        </>
      ) : (
        <FormControl isRequired isInvalid={!!errors.name}>
          <FormLabel>Nom</FormLabel>
          <Select
            options={languagesOptions}
            onChange={handleChange}
            value={watch("code") && watch("name") ? { label: watch("name"), value: watch("code") } : null}
            placeholder="Selectionner la langue"
            getOptionValue={(e) => e.value}
            components={{ Menu: CustomMenu }}
          />
          <FormErrorMessage>

          </FormErrorMessage>
        </FormControl>
      )}

      <HStack mt={10}>
        <Button
          type='submit'
          onClick={handleSubmit(onSubmit)}
          isLoading={isSubmitting}
          p='4'
          rounded='20px'
          mx='auto'
          w='40%'
          colorScheme='blue'
          variant='solid'
        >
          Ajouter
        </Button>
      </HStack>
    </form>
  )
}

export default NewLanguageForm